<template>
  <div class="outerBox">
    <div class="gHead" :style="{ fontSize: fonts.font18 + 'px' }">
      Please Confirm Posting Decision
    </div>
    <div class="detailBox" :style="{ fontSize: fonts.font16 + 'px' }">
      <div class="detailItem">
        <div class="ddRight">Amount:</div>
        <div class="ddLeft">{{ post.amount }}</div>
      </div>
      <div class="detailItem">
        <div class="ddRight">Type:</div>
        <div class="ddLeft">{{ xType }}</div>
      </div>
      <div class="detailItem">
        <div class="ddRight">From:</div>
        <div class="ddLeft">{{ post.from }}</div>
      </div>
      <div class="detailItem">
        <div class="ddRight">To:</div>
        <div class="ddLeft">{{ post.to }}</div>
      </div>
    </div>
    <b-button-group>
      <b-button class="btnGreen"
                @click="submit">
        OK
      </b-button>
      <b-button class="btnRed"
                @click="cancel">
        Cancel
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'z-confirm',
  data() {
    return {
    };
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    xType() {
      let xType = 'Unknown';
      const sTyp = this.post.source.substr(10, 1);
      const dTyp = this.post.destin.substr(10, 1);
      xType = `${sTyp} to ${dTyp}`;
      if (sTyp === 'L' && dTyp !== 'L') { xType = 'Loan Advance to Shares'; }
      if (sTyp !== 'L' && dTyp === 'L') { xType = 'Loan Payment from Shares'; }
      if (sTyp !== 'L' && dTyp !== 'L') { xType = 'Share to Share Transfer'; }
      return xType;
    },
    post() {
      return this.$store.getters.getPostData;
    },
  },
  methods: {
    submit() {
      const xfInfo = {};
      xfInfo.cun = this.cun;
      xfInfo.acct = this.post.acct;
      xfInfo.source = this.post.source;
      xfInfo.destin = this.post.destin;
      xfInfo.amount = this.post.amount;
      xfInfo.visi = this.post.visi;
      // utl.diag(xfInfo);
      this.$store.commit('doXfer', xfInfo);
      window.history.back();
      window.history.back();
    },
    cancel() { // Go Back
      this.$store.commit('setXfsRestore', true);
      window.history.back();
    },
  },
  mounted() {
    // utl.diag('z-confirm - Mounted()');
  },
  destroyed() {
    // utl.diag('z-confirm - Destroyed()');
  },
};
</script>

<style scoped>
  .outerBox {
    min-width: 300px;
    display: inline-block;
    border: solid 4px blue;
    padding: 0px 0px 10px 0px; /* top, right, bottom, left*/
  }
  .gHead {
    height: 30px;
    background: blue;
    color: white;
  }
  .rGroup {
    display: inline-block;
  }
  .btnGreen {
    background-color: lime;
    color: black;
    font-weight: bold;
    top: 5px;
    left: -10px;
  }
  .btnRed {
    background-color: red;
    color: black;
    font-weight: bold;
    top: 5px;
    right: -10px;
  }
  .detailBox {
    min-width: 100px;
    max-width: 500px;
  }
  .detailItem {
    display: inline-flex;
    width: 100%;
    horiz-align: center;
    border: dotted 1px gray;
  }
  .ddLeft {
    text-align: left;
    width: 75%;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;
  }
  .ddRight {
    text-align: right;
    width: 25%;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/z-confirm.vue